'use client';
import { useStyle } from '@/classify';
import ErrorView from '@/components/ErrorView';
import { gql, useQuery } from '@apollo/client';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { useEffect, useRef } from 'react';
import defaultClasses from './cmsBlock.module.css';

const CmsBlockGroup = props => {
  const { identifiers, sizechartdialog, hideError = false, resolveRelativePath, afterEffect } = props;
  const classes = useStyle(defaultClasses, props.classes);

  const { loading, error, data } = useQuery(GET_CMS_BLOCKS, {
    variables: {
      identifiers,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
  });
  const propsRef = useRef({ afterEffect });
  propsRef.current.afterEffect = afterEffect;

  useEffect(() => {
    if (!loading && data) {
      propsRef.current.afterEffect?.();
    }
  }, [loading, data]);

  if (!data) {
    if (loading) {
      return null;
    }

    if (error && !hideError) {
      return <ErrorView message={error.message} />;
    }

    return null;
  }

  const { items } = data.cmsBlocks;

  if (!Array.isArray(items) || !items.length) {
    return <div>There are no blocks to display</div>;
  }

  const richText = items[0]?.content || '';
  const transformedRichText =
    richText.indexOf('sizechartpartition') > -1
      ? sizechartdialog
        ? escape2Html(decodeURI(richText.replace(/%/g, '%25')).split('sizechartpartition')[1])
        : escape2Html(decodeURI(richText.replace(/%/g, '%25')).split('sizechartpartition')[0])
      : escape2Html(richText);

  if (resolveRelativePath) {
    return (
      <div className={classes.root}>
        {parse(transformedRichText, {
          replace: domNode => {
            if (domNode.name === 'a') {
              const { attribs, children } = domNode;
              let href = attribs.href;

              if (href && (href.indexOf('http') !== 0 || href.indexOf('https') !== 0)) {
                if (href.indexOf('/') !== 0) {
                  href = '/' + href;
                }

                if (href.indexOf(process.env.NEXT_PUBLIC_BASE_PATH + '/') !== 0) {
                  href = process.env.NEXT_PUBLIC_BASE_PATH + href;
                }
              }

              return (
                <a
                  {...attributesToProps(attribs)}
                  href={href}
                >
                  {domToReact(children)}
                </a>
              );
            }
          },
        })}
      </div>
    );
  }

  return (
    <div
      className={classes.root}
      dangerouslySetInnerHTML={{
        __html: transformedRichText,
      }}
    />
  );
};

export default CmsBlockGroup;

function escape2Html(str) {
  const arrEntities = {
    lt: '<',
    gt: '>',
    nbsp: ' ',
    amp: '&',
    quot: '"',
  };

  return str?.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
    return arrEntities[t];
  });
}

export const GET_CMS_BLOCKS = gql`
  query cmsBlocks($identifiers: [String]!) {
    cmsBlocks(identifiers: $identifiers) {
      items {
        content
        identifier
      }
    }
  }
`;
